export const LANGUAGES = [
    {
      label: 'English', value: 'en'
    },
    {
      label: 'हिंदी', value: 'hi'
    }
  ]